import React, { useContext, useEffect, useState } from 'react';
import PageWrapper from '../../../components/PageWrapper/PageWrapper';
import { BARRIO, BARRIO_CERRADO, BUENOS_AIRES, CABA, CALLE_INTERNA, CAPITAL, FORMULARIO_BARRIO_CERRADO_YSOCIAL, GEOLOCALIZACION_YSOCIAL_STATE, INFO_ADICIONAL, LOCALIDAD, LOTE, MANZANA, PROVINCIA } from '../../../utils/constants';
import { YsocialContext } from '../../../contexts/YsocialContext';
import { IonCol, IonContent, IonGrid, IonRow } from '@ionic/react';
import { Button, InputText, ListAutocomplete, Modal, Separador, Subtitulo, TextArea, TextLink, Titulo } from 'app-principal-componentes-visuales';
import { useHistory } from 'react-router';
import EliminarDomicilio from '../../../components/Modals/EliminarDomicilio/EliminarDomicilio';
import { useDirecciones } from '../../../hooks/useDirecciones';
import { Direccion } from '../../../interfaces/direccion.interface';
import { Localidad } from '../../../interfaces/localidad.interface';
import { capitalizeWord, textIsValid } from '../../../utils/utils';
import Normalizacion from '../../../components/Modals/Normalizacion/Normalizacion';
import './FormularioBarrioCerradoYsocial.scss';

const initialState_Direccion: Direccion = { 
    barrio: '',
    calle: '',
    altura: 'S/N',
    piso: '',
    departamento: '',
    codigoPostal: '',
    latitud: 0,
    longitud: 0,
    entreCalleUno: '',
    entreCalleDos: '',
    localidad: '',
    provincia: '',
    posicionExacta: false,
    observaciones: '',
    seleccionado: true,
    barrioCerrado: true
};

type LocationState = {
    selectedDirection?: any;
    showEliminar?: boolean;
    direccionesSocio?: any;
    fromState?: any;
    isGeo: boolean;
    existeProvincia: boolean;
};

type UbicacionState = typeof PROVINCIA | typeof LOCALIDAD | typeof BARRIO | typeof BARRIO_CERRADO;

const FormularioBarrioCerradoYsocial = () => {
    const history = useHistory();
    const { selectedDirection = null, fromState, showEliminar, isGeo } = (history.location.state as LocationState) || {};
    const { ysocial, useRequest, isWeb, dispatchYsocial, storageManager } = useContext(YsocialContext);
    const { usuario, provincias } = ysocial;
    const { apiRequest } = useRequest();
    const [ placeToEdit, setPlaceToEdit ] = useState<UbicacionState>(PROVINCIA);
    const [ direccion, setDireccion ] = useState<Direccion>(selectedDirection || initialState_Direccion);    
    const [ provinciasEncontradas, setProvinciasEncontradas ] = useState([]);
    const [ provinciasInicializadas, setProvinciasInicializadas ] = useState([]);
    const [ provinciaSearch, setProvinciaSearch ] = useState('');
    const [ localidadesEncontradas, setLocalidadesEncontradas ] = useState([]);
    const [ localidadesInicializadas, setLocalidadesInicializadas ] = useState([]);
    const [ localidadSearch, setLocalidadSearch ] = useState('');
    const [ localidadConBarrios, setLocalidadConBarrios ] = useState(false);
    const [ localidades, setLocalidades ] = useState<Localidad[]>();
    const [ barriosEncontrados, setBarriosEncontrados ] = useState([]);
    const [ barriosInicializados, setBarriosInicializados ] = useState([]);
    const [ barrioSearch, setBarrioSearch ] = useState('');
    const [ barrioCerrado, setBarrioCerrado ] = useState('');
    const [ requiereBarrio, setRequiereBarrio ] = useState(false);
    const [ newPlace, setNewPlace ] = useState<boolean>(false);
    const [ showDeleteDirectionModal, setShowDeleteDirectionModal ] = useState<boolean>(false);
    const [ showModalEditPlace, setShowModalEditPlace ] = useState<boolean>(false);
    const [ calleInterna, setCalleInterna ] = useState('');
    const [ manzana, setManzana ] = useState('');
    const [ lote, setLote ] = useState('');
    const [ informacionAdicional, setInformacionAdicional ] = useState('');

    const { 
        addDirection, 
        modifyDirection, 
        handleNormalizacion, 
        edicionDireccion, 
        merlinWaiting,
        stateMerlin, 
        showNormalizacionModal, 
        setShowNormalizacionModal, 
        updateDirection,
        handleNormalizacionEditar, 
        handleCloseModalEdit, 
        handleCloseModal
    } = useDirecciones({
        socioPrincipal: usuario, 
        apiRequest, 
        direccionesSocio: ysocial?.usuario?.direcciones, 
        isYsocial: true
    });

    useEffect(() => {
        let nombresProvincias = provincias?.map( provincia => provincia.nombre );
        setProvinciasInicializadas(nombresProvincias);
    }, [provincias])

    useEffect(() => {
        if (selectedDirection?.observaciones) {
            const observacionesAux = selectedDirection?.observaciones;
            setInformacionAdicional(observacionesAux?.split(`${INFO_ADICIONAL}:`)?.[1]?.split(`-`)?.[0] ?? '');
            setCalleInterna(capitalizeWord(observacionesAux?.split(`${CALLE_INTERNA}:`)?.[1]?.split(`-`)?.[0] ?? ''));
            setManzana(observacionesAux?.split(`${MANZANA}:`)?.[1]?.split(`-`)?.[0] ?? '');
            setLote(observacionesAux?.split(`${LOTE}:`)?.[1] ?? '');
        }
    }, [selectedDirection?.observaciones])

    useEffect(() => {
        const infoAdicionalAux = informacionAdicional ? `${INFO_ADICIONAL}:${informacionAdicional}` : '' ;
        const calleInternaAux = calleInterna ? `-${CALLE_INTERNA}:${calleInterna}` : '';
        const manzanaAux = manzana ? `-${MANZANA}:${manzana}` : '';
        const loteAux = lote ? `-${LOTE}:${lote}` : '' ;
        const observaciones = `${infoAdicionalAux}${calleInternaAux}${manzanaAux}${loteAux}`;
        setDireccion({...direccion, observaciones});

    }, [calleInterna, manzana, lote, informacionAdicional])

    useEffect(() => {
        if( selectedDirection && selectedDirection.calle ) {
            setNewPlace(false) 
            if(!(selectedDirection.provincia === BUENOS_AIRES && (selectedDirection.localidad === CABA || selectedDirection.localidad === CAPITAL))) {
                setProvinciaSearch(selectedDirection.provincia === CAPITAL ? CABA : selectedDirection.provincia);
                setLocalidadSearch(selectedDirection.localidad);
                setBarrioSearch(selectedDirection.barrio);
                setDireccion(selectedDirection);
                setBarrioCerrado(selectedDirection?.calle);
                selectedDirection.barrio !== '' ? setLocalidadConBarrios(true) : setLocalidadConBarrios(false);
            } else {
                let direccionErronea = {...selectedDirection, provincia:'', localidad:''}
                setDireccion(direccionErronea);
            }
        } else {
            setNewPlace(true)
        }
    }, [ selectedDirection ])

    useEffect(() => {
        if( provincias && direccion.provincia ) {
            direccion.provincia = direccion.provincia === CAPITAL ? CABA : direccion.provincia;
            let prov = provincias.find( prov => prov.nombre === direccion.provincia );
            setLocalidades(prov.localidades);
            let nombresLocalidades = prov?.localidades?.map( loc => loc.nombre);
            setLocalidadesInicializadas(nombresLocalidades);
        }
    }, [ direccion.provincia, provincias ])

    useEffect(() => {
        if( localidades && direccion.localidad ) {
            let localidad = localidades.find( loc => loc.nombre === direccion.localidad );
            if ( localidad?.barrios.length > 0 ) {
                let nombresBarrios = localidad?.barrios?.map( loc => loc.nombre);
                setLocalidadConBarrios(true);
                setBarriosInicializados(nombresBarrios);
            } else {
                setDireccion({...direccion, barrio: ''});
                setLocalidadConBarrios(false);
                setBarriosEncontrados([]);
            }
        }
    }, [ direccion.localidad, localidades ])

    useEffect(() => {
        if(!newPlace && direccion.localidad && localidades && barriosEncontrados.length === 0 ){
            let localidad = localidades.find( loc => loc.nombre === direccion.localidad );
            if ( localidad?.barrios.length > 0 ) {
                let nombresBarrios = localidad.barrios?.map( loc => loc.nombre);
                setLocalidadConBarrios(true);
                setBarriosInicializados(nombresBarrios);
            } else {
                setDireccion({...direccion, barrio: ''});
            }
        }
    }, [newPlace, direccion.localidad])

    /**
    * Metodo encargado de ocultar el formulario para mostrar el modulo de searchbar para provincias, localidades, barrios
    * @param campo indica cual de los searchbars se va a renderizar
    */
    const handleEditPlace = (campo: UbicacionState) => {
        setShowModalEditPlace(true);
        setPlaceToEdit(campo)
    }

    /**
     * Metodo que cambia el estado de la direccion con la provincia que se selecciono del listado
     */
    const handleAcceptProvincia = ( provinciaSeleccionada ) => {
        setProvinciaSearch(provinciaSeleccionada);
        setLocalidadesEncontradas([]);
        setLocalidadSearch("");
        setBarriosEncontrados([]);
        if(provinciaSeleccionada === CABA){
            setLocalidadConBarrios(true)
            setRequiereBarrio(true)
            setDireccion({...direccion, provincia:provinciaSeleccionada, localidad:'CIUDAD AUTONOMA BUENOS AIRES', barrio:''});
        }else{
            setLocalidadConBarrios(false)
            setRequiereBarrio(false)
            setDireccion({
                ...direccion, 
                provincia:provinciaSeleccionada, 
                localidad:'', 
                barrio:''
            });
        }
        setShowModalEditPlace(false)
    }

    /**
    * Metodo que setea en el state el input de provincias al realizarse una modificacion y filtra las provincias mostradas en pantalla
    */
    const handleInputChangeProvincia = ({target}) => {
        let {value} = target;
        if(provinciaSearch !== value) {
            if (value.length < 3) {
                setProvinciasEncontradas([]);
            } else { 
                let provinciasBuscadas = provinciasInicializadas.filter((item) => {return item.toUpperCase().includes(value.toUpperCase())});
                setProvinciasEncontradas(provinciasBuscadas);
            }
            setProvinciaSearch(value);
        }
    }

    /**
    * Metodo que cambia el estado de la direccion con la localidad que se selecciono del listado
    */
    const handleAcceptLocalidad = ( localidadSeleccionada ) => {
        setLocalidadSearch(localidadSeleccionada);
        setBarriosEncontrados([]);
        setBarrioSearch('');
        setDireccion({
            ...direccion, 
            localidad: localidadSeleccionada, 
            barrio:'',
        });
        setShowModalEditPlace(false)
    }

    /**
    * Metodo que setea en el state el input de localidades al realizarse una modificacion y filtra las localidades mostradas en pantalla
    */
    const handleInputChangeLocalidad = ({target}) => {
        let {value} = target;
        if(localidadSearch !== value) {
            if (value.length < 3) {
                setLocalidadesEncontradas([]);
            } else { 
                let localidadesBuscadas = localidadesInicializadas.filter((item) => {return item.toUpperCase().includes(value.toUpperCase())})
                setLocalidadesEncontradas(localidadesBuscadas);
            }
            setLocalidadSearch(value);
        }
    }

    /**
    * Metodo que cambia el estado de la direccion con el barrio que se selecciono del listado
    */
    const handleAcceptBarrio = ( barrioSeleccionado ) => {
        setBarrioSearch(barrioSeleccionado);
        setDireccion({...direccion, barrio:barrioSeleccionado});
        setShowModalEditPlace(false)
    }

    /**
    * Metodo que setea en el state el input del barrio al realizarse una modificacion y filtra los barrios mostrados en pantalla
    */
    const handleInputChangeBarrio = ({target}) => {
        let {value} = target;
        if(barrioSearch !== target) {
            if (value.length < 3) {
                setBarriosEncontrados([]);
            } else { 
                let barriosBuscados = barriosInicializados.filter((item) => {return item.toUpperCase().includes(value.toUpperCase())})
                setBarriosEncontrados(barriosBuscados)
            }
            setBarrioSearch(value);
        }
    }

    /**
    * Metodo que setea en el state el input del del barrio privado al realizarse una modificacion
    */
    const handleBarrioCerradoChange = ({target}) => {
        const noSpacesValue = target.value.replace(/^\s+/, '');
        const isValid = textIsValid(target.value)
        if(isValid){
            setBarrioCerrado(noSpacesValue);
            setDireccion({...direccion, calle: noSpacesValue})
        } 
    }

    /**
    * Metodo que setea en el state el input de la calle interna al realizarse una modificacion
    */
    const handleCalleInternaChange = (e) => {
        const noSpacesValue = e?.target?.value?.replace(/^\s+/, '');
        const isValid = textIsValid(e?.target?.value)
        if(isValid){
            setCalleInterna(noSpacesValue);
        } 
    }

    /**
     * Metodo que setea en el state el input del manzana al realizarse una modificacion
     */
    const handleManzanaChange = (e) => {
        const noSpacesValue = e?.target?.value?.replace(/^\s+/, '');
        const isValid = textIsValid(e?.target?.value)
        if(isValid){
            setManzana(noSpacesValue);
        } 
    }

    /**
     * Metodo que setea en el state el input del lote al realizarse una modificacion
     */
    const handleLoteChange = (e) => {
        const noSpacesValue = e?.target?.value?.replace(/^\s+/, '');
        const isValid = textIsValid(e?.target?.value)
        if(isValid){
            setLote(noSpacesValue);
        } 
    }

    /**
     * Metodo que setea en el state el input de la información adicional al realizarse una modificacion
     */
    const handleInfoAdicionalChange = (e) => {
        const noSpacesValue = e?.target?.value.replace(/^\s+/, '');
        const isValid = textIsValid(e?.target?.value)
        if(isValid){
            setInformacionAdicional(noSpacesValue);
        } 
    }

    /**
     * Metodo que elimina la direccion seleccionada del socio principal
     */
    const deleteDirection = (direccionId) => {
        let direccionSinSeleccionado = [];
        const direccionFiltrada = usuario?.direcciones?.filter(direccion => {
            return direccionId !== direccion.id
        });

        if (direccionId === selectedDirection.id && direccionFiltrada.length !== 0) {
            direccionSinSeleccionado = direccionFiltrada.map((direccion, index) => {
                if (index === direccionFiltrada.length - 1) {
                    let dirSelected = { ...direccion, seleccionado: true }
                    return dirSelected
                }
                return direccion
            });
        }
        updateDirection(direccionSinSeleccionado.length > 0 ? direccionSinSeleccionado : direccionFiltrada);
        setShowDeleteDirectionModal(!showDeleteDirectionModal);
        
        history.goBack();
    }

    /**
     * Metodo que realiza el llamado a la modificacion o alta de una direccion
     */
    const handleSubmit = () => {
        const { calle } = direccion;
        direccion.calle = ( calle?.toLocaleUpperCase().includes('BO') ? '' : 'BO ' ) + calle;
        if (direccion.provincia === CABA)
            direccion.provincia = CAPITAL
            if(newPlace){
                addDirection(direccion)
            } else {
                modifyDirection(direccion)
        }
    }

    /**
     * Encargado de abrir/cerrar el modal de eliminacion de direcciones
     */
    const openDeleteDirection = () => setShowDeleteDirectionModal(showDelete => !showDelete);

    /**
    * Metodo que permite mostrar el formulario al cancelarse el ListAutocomplete
    */
    const handleCancel = (direccionCancel) => {
        if (direccionCancel === PROVINCIA) {
            if(direccion.provincia !== '') {
                setProvinciaSearch(direccion.provincia);
            } else {
                setProvinciaSearch('')
                setProvinciasEncontradas([]);
            }
        }
        else if (direccionCancel === LOCALIDAD) {
            if(direccion.localidad !== '') {
                setLocalidadSearch(direccion.localidad);
            } else {
                setLocalidadesEncontradas([]);
                setLocalidadSearch('');
            }
        }
        else if (direccionCancel === BARRIO) {
            if(direccion.barrio !== '') {
                setBarrioSearch(direccion.barrio);
            } else {
                setBarriosEncontrados([]);
                setBarrioSearch('');
            }
        }
        setShowModalEditPlace(false);
    }

    /**
     * Validacion del disable del boton guardar
     */
    const validPlace =     
        direccion.calle === '' || 
        direccion.provincia === '' || 
        direccion.localidad === '' || 
        (requiereBarrio && direccion.localidad !== '' && direccion.barrio === '') || 
        direccion.observaciones?.length > 100 ||
        !calleInterna;

    const propsAutocompleteList = {
        provincia: {
            id: 'provincias-list',
            name: 'provinciaSearch',
            label: 'Provincia',
            placeholder: 'Elegí la provincia',
            list: provinciasEncontradas,
            valueInputDefault: provinciaSearch,
            aceptarValor: handleAcceptProvincia,
            onClickCancelar: ()=> handleCancel(PROVINCIA),
            onHandleInputChange: handleInputChangeProvincia,
        },
        localidad: {
            id: 'localities-list',
            name: 'localidadSearch',
            label: 'Localidad',
            placeholder: 'Elegí la localidad',
            list: localidadesEncontradas,
            valueInputDefault: localidadSearch,
            aceptarValor: handleAcceptLocalidad,
            onClickCancelar: () => handleCancel(LOCALIDAD),
            onHandleInputChange: handleInputChangeLocalidad,
        },
        barrio: {
            id: 'barrio-list',
            name: 'barrioSearch',
            label: 'Barrio',
            placeholder: 'Elegí el barrio',
            list: barriosEncontrados,
            aceptarValor: handleAcceptBarrio,
            valueInputDefault: barrioSearch,
            onClickCancelar: () => handleCancel(BARRIO),
            onHandleInputChange: handleInputChangeBarrio,
        }
    }

    return (
        <PageWrapper
            socio={usuario}
            pageClassName="formulario-barrio-cerrado-ysocial"
            path={FORMULARIO_BARRIO_CERRADO_YSOCIAL}
            tituloHeader='Datos de Ubicación'
            className={isWeb ? 'asistencia-formulario':'asistencia-formulario asistencia-formulario-mobile'}
        >
            <IonGrid>
                <IonCol className='titulo'>
                    <Titulo 
                        className="titulo-asitencia-formulario-domicilio"
                        titulo={newPlace || isGeo ? 'Nuevo domicilio' : 'Editar domicilio'}
                    />
                </IonCol>
                {
                    (!newPlace && !isGeo) &&
                    <IonCol size='2' className='col__align'> 
                        { showEliminar && 
                            <TextLink
                                id='asistencia__formulario-domicilio'
                                onClick={openDeleteDirection}
                                right
                                texto="Eliminar"
                            />
                        }
                    </IonCol>
                }
            </IonGrid>
        <IonGrid>
            <IonRow>
                <IonCol size='12'>
                    <Subtitulo 
                        id="subtitulo-info" 
                        titulo='Barrio cerrado / country' 
                    />
                </IonCol>
                <IonCol size='12'>
                    <InputText
                        id='formulario-input-barrio-cerrado'
                        normalLink
                        label='Nombre del barrio / country'
                        placeholder='Ingresá el nombre'
                        type='text'
                        value={barrioCerrado} 
                        onIonChange={handleBarrioCerradoChange}
                    />
                </IonCol>
                <IonCol size='12' className='col--padding-right col--padding-top'>
                    <InputText
                        id='formulario-input-calle'
                        normalLink
                        label='Calle interna'
                        placeholder='Ingresá la calle interna de tu domicilio'
                        type='text'
                        value={calleInterna} 
                        onIonChange={handleCalleInternaChange}
                    />
                </IonCol>
                <IonCol size='6' className='col--padding-right col--padding-top'>
                    <InputText
                        id='formulario-input-manzana'
                        label='Manzana'
                        normalLink
                        placeholder='Opcional'
                        type='text'
                        value={manzana} 
                        onIonChange={handleManzanaChange}
                    />
                    
                </IonCol>
                <IonCol size='6' className='col--padding-left col--padding-top'>
                    <InputText
                        id='formulario-input-lote'
                        label='Lote'
                        normalLink
                        placeholder='Opcional'
                        type='text'
                        value={lote}
                        onIonChange={handleLoteChange}
                    />
                </IonCol>
            </IonRow>
            <Separador />
            <IonRow>
                <IonCol size='12'>
                    <InputText
                        id='formulario-input-provincia'
                        elegirLink
                        label='Provincia'
                        onClick={() => handleEditPlace(PROVINCIA)}
                        placeholder='Elegí la provincia'
                        type='text'
                        value={direccion.provincia === CAPITAL ? CABA : direccion.provincia} 
                    />
                </IonCol>
                <IonCol size='12' className='col--padding-top'>
                    <InputText
                        id='formulario-input-localidad'
                        disable = { direccion.provincia === undefined || direccion.provincia === '' }
                        elegirLink
                        label='Localidad'
                        onClick={() => handleEditPlace(LOCALIDAD)}
                        placeholder='Elegí la localidad'
                        type='text'
                        value={direccion.localidad} 
                    />
                </IonCol>
                { localidadConBarrios && (
                    <IonCol size='12' className='col--padding-top'>
                        <InputText
                            id='formulario-input-barrio'
                            disable = { direccion.localidad === undefined || direccion.localidad === ''}
                            elegirLink
                            label='Barrio'
                            onClick={() => handleEditPlace(BARRIO)}
                            placeholder='Elegí el barrio'
                            type='text'
                            value={direccion.barrio} 
                        />
                    </IonCol>
                )}
            </IonRow>
            <IonRow>
                <IonCol size='12' className='col--padding-top'>
                    <Subtitulo 
                        id="subtitulo-info" 
                        titulo='¿Hay información adicional que quieras comentarnos?' 
                    />
                </IonCol>
                <IonCol size='12'>
                    <TextArea
                        id="text-area-info-adicional"
                        label='Información adicional'
                        maxLength={ 100 - ( calleInterna ? 3 + calleInterna.length : 0 ) - ( manzana ? 3 + manzana.length : 0 ) - ( lote ? 6 + lote.length : 0 )}
                        placeholder='Ingresá tu manzana, country, lote, etc.'
                        value={informacionAdicional} 
                        onIonChange={handleInfoAdicionalChange}
                    />
                </IonCol>
            </IonRow>
            <IonCol size='12' className='guardar-cambios'>
                <Button 
                    id='formulario-domicilio-guardar'
                    className='button--margin' 
                    label={ newPlace ? 'Agregar':'Guardar cambios' } 
                    onClick={ handleSubmit }
                    disable={ validPlace }
                    waiting={ Boolean(merlinWaiting) } 
                    primary 
                />
            </IonCol>
        </IonGrid>
            {/* MODALES */}
            <Modal
                className='modal_web-large'
                component={
                    <IonContent className='asistencia-formulario'>
                        <IonGrid className='asistencia-formulario__header'>
                            <IonRow>
                                <IonCol size='12' className='titulo'>
                                    <Titulo titulo={'Nuevo domicilio'} />
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                        <IonGrid style={{marginTop:'120px'}}>
                            <IonRow style={{display: 'flex', justifyContent: 'center'}}>
                                <IonCol size='11'>
                                    <ListAutocomplete
                                        {...propsAutocompleteList[placeToEdit]}
                                    />
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonContent>
                }
                setShowModal={setShowModalEditPlace}
                showModal={showModalEditPlace}
                id="formulario-domicilio-modal"
            />

        <Modal
            className='modal_web'
            screen60
            hideCloseBtn
            //@ts-ignore
            component={
                <Normalizacion
                    isWeb={isWeb}
                    onClick={(data) => edicionDireccion ? handleNormalizacionEditar(data) : handleNormalizacion(data)}
                    closeModal={edicionDireccion ? handleCloseModalEdit : handleCloseModal}
                    data={stateMerlin}
                    isBarrioCerrado
                />
            }
            setShowModal={setShowNormalizacionModal}
            showModal={showNormalizacionModal}
            id="modal-normalizacion"
        />

            <Modal
                className='modal_web_xl'
                hideCloseBtn
                //@ts-ignore
                component={
                    <EliminarDomicilio
                        openDeleteDirection={openDeleteDirection} 
                        selectedDirection={selectedDirection} 
                        deleteDirection={deleteDirection}
                        isWeb={isWeb} 
                    />
                }
                setShowModal={setShowDeleteDirectionModal}
                showModal={showDeleteDirectionModal}
                id="eliminar-domicilio-modal"
            />
        </PageWrapper>
    )
}

export default FormularioBarrioCerradoYsocial
